import { render } from "./AddThing.vue?vue&type=template&id=89e9e51e&lang=pug"
import script from "./AddThing.vue?vue&type=script&lang=js"
export * from "./AddThing.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__